import { useState, useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
export default function CarFunctionalPPF() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const tags = ["Sunroof Film", "Windshield Film", "Car Headlight Film"];
  const stats = [{
    value: "190%",
    label: "Max Breaking Stretch"
  }, {
    value: "2×",
    label: "Surface Passivation Treatments"
  }, {
    value: "5th",
    label: "Generation Hydrogen-Bond Coating"
  }];
  return <section ref={sectionRef} className="bg-background text-foreground overflow-hidden relative">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@300;400;500&display=swap');`}</style>

      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-[60vw] h-[2px] bg-primary opacity-30" style={{
        transform: "translateX(-10%)"
      }} />
        <div className="absolute bottom-0 right-0 w-[40vw] h-[2px] bg-primary opacity-20" />
        <div className="absolute right-0 top-0 h-full w-[1px] bg-border opacity-40" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-20 md:py-32">
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="lg:col-span-5 flex flex-col justify-between gap-10">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="h-[3px] w-10 bg-primary" />
                <span className="text-xs font-medium tracking-[0.3em] uppercase text-muted-foreground" style={{
                fontFamily: "'Inter', sans-serif"
              }}>
                  Product Series
                </span>
              </div>

              <h2 className="text-[clamp(3rem,8vw,7rem)] leading-none tracking-tight text-foreground uppercase" style={{
              fontFamily: "'Bebas Neue', sans-serif"
            }}>
                Car
                <br />
                <span className="text-primary">Functional</span>
                <br />
                PPF Series
              </h2>
            </div>

            <div className="flex flex-wrap gap-2">
              {tags.map(tag => <Badge key={tag} variant="outline" className="px-4 py-2 text-xs tracking-widest uppercase border-border text-muted-foreground hover:border-primary hover:text-primary transition-colors duration-300 cursor-default rounded-none" style={{
              fontFamily: "'Inter', sans-serif"
            }}>
                  {tag}
                </Badge>)}
            </div>
          </div>

          <div className="lg:col-span-1 flex lg:flex-col items-center justify-center">
            <Separator orientation="vertical" className="hidden lg:block h-full opacity-30" />
            <Separator orientation="horizontal" className="block lg:hidden w-full opacity-30" />
          </div>

          <div className="lg:col-span-6 flex flex-col justify-between gap-12">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground font-light max-w-xl" style={{
            fontFamily: "'Inter', sans-serif"
          }}>
              The fifth-generation hydrogen-bond patented coating has undergone two surface passivation treatments, and has super anti-permeability, scratch repair memory function; prevent water stains, extinction, and extreme anti-fouling. The strongest breaking stretch can reach 190%, and the coating can be repaired without heating.
            </p>

            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, i) => <div key={stat.label} className={`group relative border border-border p-5 hover:border-primary transition-all duration-500 cursor-default ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: `${300 + i * 120}ms`,
              fontFamily: "'Inter', sans-serif"
            }}>
                  <div className="absolute inset-0 bg-primary opacity-0 group-hover:opacity-5 transition-opacity duration-500" />
                  <div className="text-3xl md:text-4xl font-semibold text-foreground tracking-tight" style={{
                fontFamily: "'Bebas Neue', sans-serif"
              }}>
                    {stat.value}
                  </div>
                  <div className="text-[10px] md:text-xs text-muted-foreground uppercase tracking-widest mt-1 leading-snug">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}